var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'תוקף',"error-message":_vm.expiration.error,"focused":_vm.focused,"empty":_vm.expiration.isEmpty}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb2a4cba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/subscription/components/credit-card-fields/Expiration.vue
// module id = null
// module chunks = 